import MoreVertIcon from '@mui/icons-material/MoreVert'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import React, { useCallback, useState } from 'react'

import T from 'T'
import { Z_INDEX } from 'theme/zIndex'

const { MENU } = Z_INDEX

export interface MoreAction {
  title: string
  icon: React.ReactNode
  onClick: () => void
}

export interface MoreActionsSection {
  title: string
  actions: MoreAction[]
}

interface MoreActionsMenuProps {
  sections: MoreActionsSection[]
}

const MoreActionsMenu = ({ sections }: MoreActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleOpen = useCallback((event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget), [])

  const handleClose = useCallback(() => setAnchorEl(null), [])

  const handleSelect = useCallback(
    (onClick: () => void) => () => {
      setAnchorEl(null)
      onClick()
    },
    []
  )

  const visibleSections = sections.filter(({ actions }) => actions.length > 0)

  return (
    <>
      <IconButton aria-haspopup="true" aria-label={T.MORE_ACTIONS} size="large" onClick={handleOpen}>
        <MoreVertIcon sx={{ color: 'grey.500' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        open={Boolean(anchorEl)}
        sx={{ zIndex: MENU }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
      >
        {visibleSections.flatMap(({ title, actions }, index) => [
          ...(index > 0 ? [<Divider key={`${title}-divider`} />] : []),
          <ListSubheader key={title} disableSticky>
            {title}
          </ListSubheader>,
          ...actions.map(action => (
            <MenuItem key={action.title} onClick={handleSelect(action.onClick)}>
              <ListItemIcon>{action.icon}</ListItemIcon>
              <ListItemText primary={action.title} />
            </MenuItem>
          )),
        ])}
      </Menu>
    </>
  )
}

export default MoreActionsMenu
